const {store, AoflElement} = aofljs;
/**
 * @summary WiaVideoPopup
 * @class WiaVideoPopup
 * @extends {AoflElement}
 */
class WiaVideoPopup extends AoflElement {
  /**
   * Creates an instance of WiaVideoPopup.
   * @memberof WiaVideoPopup
   */
  constructor() {
    super(store);
    let state = store.getState();
    let userSession = state.userSession;
    let wiaLauncher = state.wiaLauncher;
    this.video = wiaLauncher.videoPath;
    this.isDesktopSafari = !userSession.isMobile && userSession.isSafari;
    if (this.isDesktopSafari) {
      this.boundToggleSize = this.toggleSize.bind(this);
      this.handleDesktopSafariFullscreenChange();
    }
  }

  /**
   *
   * @readonly
   * @static
   * @memberof WiaVideoPopup
   */
  static get is() {
    return 'wia-video-popup';
  }

  /**
   *
   *
   * @memberof WiaVideoPopup
   */
  handleDesktopSafariFullscreenChange() {
    window.addEventListener('resize', this.boundToggleSize);
  }

  /**
   *
   *
   * @memberof WiaVideoPopup
   */
  toggleSize() {
    // If the value is null, this means the browser is not longer in full screen mode.
    if (document.webkitFullscreenElement === null) {
      this.style.width = '80rem';
      this.style.height = '45rem';
    } else if (this.style.width !== '100%') {
      this.style.width = '100%';
      this.style.height = '100%';
    }
  }

  /**
   *
   *
   * @memberof WiaVideoPopup
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.isDesktopSafari) {
      window.removeEventListener('resize', this.boundToggleSize);
    }
  }
}

window.customElements.define(WiaVideoPopup.is, WiaVideoPopup);

export default WiaVideoPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/wia-video-popup/wia-video-popup.js